import { render } from "./ConfirmAmountTopUp.vue?vue&type=template&id=a3a3fd62"
import script from "./ConfirmAmountTopUp.vue?vue&type=script&lang=js"
export * from "./ConfirmAmountTopUp.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__